import { asyncRoutes } from '@/router/routes/index'
import { PAGE_NOT_FOUND_NAME } from '@/router/constant'
// const IFrame = () => import('@/layouts/frame/FrameBlank.vue');

const state = {
  // routes: [],
  isDynamicAddedRoute: false,
}

const getters = {
  getIsDynamicAddedRoute: (state) => {
    return state.isDynamicAddedRoute
  },
}

const mutations = {
  // SET_ROUTES(state, payload) {
  //   state.routes = payload
  // },

  RESET_STATE(state) {
    state.routes = []
    state.isDynamicAddedRoute = false
  },

  setDynamicAddedRoute(state, added) {
    state.isDynamicAddedRoute = added
  },
}

const actions = {
  buildRoutesAction({ rootGetters }) {
    return new Promise((resolve) => {
      const menuIndexMap = rootGetters['user/getMenuIndexMap']

      if (!menuIndexMap || !Object.keys(menuIndexMap).length) {
        resolve(asyncRoutes.filter((route) => route.name === PAGE_NOT_FOUND_NAME))
        return
      }

      let accessedRoutes
      let allAsyncRoutes = [...asyncRoutes]

      accessedRoutes = allAsyncRoutes.filter((route) => {
        const { name, path } = route
        if (name === PAGE_NOT_FOUND_NAME) {
          return route
        }
        const _path = path.startsWith('/') ? path : `/${path}`
        const menuItem = menuIndexMap[_path]

        if (!route.meta) {
          route.meta = {}
        }

        return menuItem
      })

      resolve(accessedRoutes)
    })
  },
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
}
